import homeReducer from "./homeReducer";
import loginReducer from "./loginReducer";
import { transportReqReducer } from "./transportReqReducer";
import { servicesActsReducer } from "./servicesActsReducer";
import { auctionReducer } from "./auctionReducer";
import {yardReducer} from "./yardReducer";
import {reportsReducer} from "./reportsReducer";
import {apiReducer} from "./apiReducer";
import {helpReducer} from "./helpReducer";

const rootReducer = {
    appState: homeReducer,
    loginState: loginReducer,
    transportState: transportReqReducer(),
    auctionState: auctionReducer(),
    servicesActsState: servicesActsReducer(),
    yardState: yardReducer(),
    reportsState: reportsReducer(),
    apiState: apiReducer(),
    helpState: helpReducer()
};

export default rootReducer;